
var Model = require("../types/Model.js");
var xtend = require("xtend");
var loadImage = require("../../polyfills/LoadImage.js");

module.exports = new Model({
	name: "livechatmessages",
	init: init,
	uninit: uninit,
	listeners: listeners,
	triggers: triggers,

	recalculate: recalculate,
	addPerson: addPerson,
	refresh: refresh,
	setEnd: setEnd,
	emit_network_toast: emit_network_toast,
	clear_pending_message: clear_pending_message,
	close_upload_dialog: close_upload_dialog,
	scroll: scroll
});

function init(){
	this._rawList = [];
	this._end = true;
	this._page = 0;
	this._session = null;
	this.push({
		list: [],
		uploading: null,
		page: 0,
		isEnd: false,
		new_content: "",
		pendingList: [],
		defaultMessage: "",
	});
}

function uninit(){
}

function triggers(){
	return {
		"send": send_message,
		"more": load_more,
		"reset": reset,

		"upload:start": upload_start,
		"upload:confirm": upload_confirm,
		"upload:finish": upload_finish,
		"upload:cancel": close_upload_dialog,
	};
}


function listeners(){
	return {
		"activelivechatsession:updated": handle_active_updated,
		"activelivechatsession:viewing": handle_active_viewing,
		"people:updated": Model.makeRecalculator("people"),
		"mqtt:$/livechat/message": handle_new_message,
		"mqtt:$/livechat/message/sent": handle_new_message,
		"mqtt:$/livechat/message/read": handle_message_read
	};
}

function recalculate(){
	var people = this._people;
	var messages = this._rawList;
	var session = this._session;
	var page = this._page;
	var end = this._end;

	if(!session) return;

	var newMessages = messages.map(function(message){
		var update = {};
		if(message.from === "system"){
			var metadata = message.metadata;
			var person = metadata.data;
			if(!person) return message;
			var newPerson = people[person];
			if(!newPerson) return message;
			update = {
				metadata: {
					type: metadata.type,
					data: newPerson
				}
			};
		} else {
			var who = message.from || "";
			var newWho = people[who];
			if(!newWho) return message;
			update = {
				from: newWho
			};
		}
		return xtend(message, update);
	});

	this._list = newMessages;
	this.extend({
		isEnd: end,
		list: newMessages,
		page: page
	});
}

function handle_active_updated(data){
	if(!data) return;
	var session = this._session;
	if(!session) return;

	this._session = data;
}

function handle_active_viewing(data){
	if(!data) return;
	this._session = data;
	var who = data.who || {};
	var isMember = this.config.id === who._id;
	var to = who._id;
	if(isMember)
		to = data.owner._id;
	this.api.livechat.message.read(data._id, to);
	this.refresh();
}

function refresh(){
	var session = this._session;
	var page = this._page;

	if(!session) return;

	this.emit("save:trigger:start");

	return this.api.livechat.message.list(session._id, page)
		.then(addPeople.bind(this))
		.then(setMessages.bind(this))
		.then(scroll.bind(this))
		.catch(finish_save.bind(this));
}

function setMessages(list){
	var timeStamped = list.reverse().map(timestampify);
	this.setEnd(timeStamped);
	this.emit("save:trigger:finish");
	this._rawList = timeStamped.concat(this._rawList);
	return this.recalculate();
}

function scroll(){
	setTimeout(function(){
		this.dispatch("scroll");
	}.bind(this), 500);
}

function handle_message_read(data){
	var session = this._session;
	var currentList = this._rawList;

	if(!session) return;
	if(session._id !== data.session) return;

	var newList = currentList.map(function(message, index){
		if(index === (currentList.length - 1))
			return timestampify(xtend(message, {
				updated_at: data.time,
				read: true
			}));
		return message;
	});

	this._rawList = newList;
	this.recalculate();
	this.scroll();
}

function handle_new_message(message){
	var session = this._session;
	var current = this._rawList;

	if(!session) return;
	if(session._id !== message.session) return;

	var who = session.who || {};
	var isMember = this.config.id === who._id;
	var to = who._id;
	if(isMember)
		to = session.owner._id;

	var newList = current.concat(timestampify(message));

	this._rawList = newList;
	this.recalculate();
	this.scroll();
	this.api.livechat.message.read(session._id, to);
}

function addPeople(list){
	this.addPerson(list.map(function(message){
		return message.from;
	}));
	return list;
}

function addPerson(person){
	this.emit("people:trigger:add", {
		lean: true,
		who: person
	});
}

function finish_save(){
	this.emit("save:trigger:finish");
}

function send_message(data){
	var session = this._session;
	var content = data.content;
	var who = session.who || {};
	var isMember = this.config.id === who._id;
	var to = who._id;
	if(isMember)
		to = session.owner._id;

	this.extend({
		new_content: "",
		pendingList: this.data.pendingList.concat(data)
	});

	this.emit("usermetrics:trigger:track", "send livechat message", {
		"livechat session": session._id
	});

	return this.api.livechat.message.send(session._id, content, to)
		.then(clear_pending_message.bind(this, data))
		.catch(handle_send_error.bind(this, data));
}

function setEnd(list){
	if(list.length < 20) this._end = true;
	else this._end = false;
}

function load_more(){
	this._page = ++this._page;
	this.refresh();
	this.emit("usermetrics:trigger:track", "load more livechat messages", {
		"livechat session": this._session._id
	});
}

function clear_pending_message(message) {
	var pendingList = this.data.pendingList.filter(function(pendingMessage){
		return pendingMessage !== message;
	});
	this.extend({
		pendingList: pendingList
	});
}

function reset(){
	this._rawList = [];
	this._end = true;
	this._page = 0;
	this._session = null;
	this.push({
		list: [],
		uploading: null,
		page: 0,
		isEnd: false,
		new_content: "",
		pendingList: []
	});
	this.emit("usermetrics:trigger:track", "close livechat session", {
		"livechat session": this._session._id
	});
}

function timestampify(item) {
	var attachment = item.attachment;
	var expires_at;
	if(attachment)
		expires_at = attachment.expires_at;
	return xtend(item, {
		expiry: timestamp(expires_at),
		date_expiry: formatDate(expires_at),
		read_timestamp: timestamp(item.updated_at),
		read_formatted_date: formatDate(item.updated_at),
		timestamp: timestamp(item.created_at),
		formatted_date: formatDate(item.created_at)
	});
}

// Converts a date timestamp into a human readable timestamp
function timestamp(value) {
	if (!value) return ""; // Ignore empty values
	var d = new Date(value);
	var res = "";
	res += padNumber(d.getHours());
	res += ":" + padNumber(d.getMinutes());
	return res;
}

// Converts a date timestamp into a human readable date
function formatDate(value) {
	if (!value) return ""; // Ignore empty values
	var d = new Date(value);
	var res = "";
	res += padNumber(d.getDate());
	res += "/" + padNumber(d.getMonth() + 1);
	return res;
}

// Pads numbers less than 10 with a 0
function padNumber(number) {
	if (number < 10) return "0" + number;
	return number;
}

function upload_start(){
	this.extend({
		uploading: true
	});
	this.emit("usermetrics:trigger:track", "begin uploading file to livechat", {
		"livechat session": this._session._id
	});
}

function close_upload_dialog(){
	this.extend({
		uploading: false,
		file: null,
		fileImage: null
	});
	this.emit("usermetrics:trigger:track", "close upload file to livechat popup", {
		"livechat session": this._session._id
	});
}

function upload_confirm(data){
	var file = data.file;
	loadImage(file).then(function(image){
		this.extend({
			uploading: false,
			file: file,
			fileImage: image
		});
	}.bind(this));
	this.emit("usermetrics:trigger:track", "upload file to livechat", {
		"livechat session": this._session._id
	});
}

function upload_finish(){
	var file = this.data.file;
	var session = this._session;
	var who = session.who || {};
	var isMember = this.config.id === who._id;
	var to = who._id;
	if(isMember)
		to = session.owner._id;

	var message = {
		file: file
	};

	this.extend({
		pendingList: this.data.pendingList.concat(message)
	});
	this.scroll();
	this.close_upload_dialog();
	return this.api.livechat.message.sendFile(session._id, file, to)
		.then(clear_pending_message.bind(this, message))
		.catch(handle_send_error.bind(this, message));
}

function emit_network_toast(){
	this.emit("toast:trigger:show", {
		content: "groupchat.errornetwork",
		style: "error",
		immediate: true
	});
}


function handle_send_error(message, error){
	console.error("Couldn't send message:", error);
	this.emit_network_toast();

	this.clear_pending_message(message);
}
